import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

export interface UserRoleDto {
  id: string;
  name: string;
  description: string;
  administrator: boolean;
}

export interface BusinessUserDto {
  id: string;
  emailAddress: string;
  userRoleId: string;
  hasSignedIn: boolean;
  isErrorRecipient: boolean;
}

export interface BusinessUserUpsertDto {
  emailAddress: string;
  userRoleId: string;
  addAsErrorRecipient: boolean;
}

export interface BusinessUsersDto {
  userRoles: UserRoleDto[];
  users: BusinessUserDto[];
}

const useGetUsers = (options?: QueryOptions<BusinessUsersDto>) => {
  const { selectedBusiness } = useUser();

  return useUserQuery<BusinessUsersDto>(
    { path: `/api/businesses/${selectedBusiness?.id}/users` },
    options);
}

export default useGetUsers;
